import React from "react";
import { Drawer as MUIDrawer } from "@material-ui/core";
import xIcon from "../../assets/img/x-icon-black.svg";
import styled from "styled-components";

const DrawerOuterContainer = styled.div`
  position: relative;
  height: 100%;
  overflow-y: auto;
  width: 646px;
`;
const DrawerContainer = styled.div`
  padding: 32px;
`;
const CloseDrawerButton = styled.div`
  position: absolute;
  right: 32px;
  top: 32px;
`;

export default function Drawer({ show, onClose, className, children, closeButton = true }) {
  return (
    <MUIDrawer anchor="right" open={show} onClose={onClose}>
      <DrawerOuterContainer className="custom-scrollbar">
        <DrawerContainer className={`drawer-overflow ${className || ""}`}>
          {closeButton && (
            <CloseDrawerButton className="d-flex border-0 c-pointer align-items-center ">
              <img alt="Fechar gaveta" className="ms-2" src={xIcon} onClick={onClose} />
            </CloseDrawerButton>
          )}
          {children}
        </DrawerContainer>
      </DrawerOuterContainer>
    </MUIDrawer>
  );
}
